import { useState } from 'react';
import { lastPosEvents } from '../pos/sessions';
import { Tile, TileGroup } from './ui';

/**
 * Kachel „Kasse fortsetzen“ für Startseite und „Meine Einsätze“: ein Tipp zur zuletzt benutzten Kasse dieses Geräts.
 * Erscheint nur, wenn das Gerät eine Kasse gemerkt hat (lokal, nur Basar-Titel). Eine Kasse mit Schnellzugang (ohne Konto)
 * führt auf die Geräte-Seite, die keine Anmeldung braucht; `deviceOnly` zeigt für Gäste (nicht angemeldet) nur diese.
 */
export function ContinueRegister({ deviceOnly = false }: { deviceOnly?: boolean }) {
  const [last] = useState(() => lastPosEvents()[0]);
  if (last === undefined || (deviceOnly && last.device !== true)) return null;
  return (
    <TileGroup>
      <Tile
        to={
          last.device === true ? `/kasse-geraet/${last.eventId}` : `/basare/${last.eventId}/kasse`
        }
        icon="euro"
        title={last.title === null ? 'Kasse fortsetzen' : `Kasse fortsetzen: ${last.title}`}
        description="Weiter mit der Kasse dieses Geräts, auch ohne Netz"
      />
    </TileGroup>
  );
}
